module.exports = __webpack_public_path__ + "static/img/4.48e5c49a.png";